import Vue from "vue";
import Vuex from "vuex";
import mixin from "@/mixins/ScreenCheckMixins.js";
import Axios from "axios";
import * as socketio from "../plugins/socketio/socketio";
import {
  bank,
  selections,
  status,
  kategori,
  project,
  alokasi,
  usedFor,
  sites,
  basicConfig,
  mataUang,
  bod,
  satuan,
  user,
  publik,
  gudang,
  produk,
  ga,
  vpm,
  specialmenu,
  navigation,
  notification,
  kurir,
  notif,
  env,
  transaction,
  costCenter,
  umpd,
  typepage,
  accountpay,
  accountreceiveable,
  sppd,
  preloader,
  director,
  salesContract,
  financing,
  paymentschedule,
  terminRelease,
  penarikanFinancing,
  administrator,
  reconciliation,
  bankguarantee,
  cashonbank,
  bidbondrequest,
  bidbond,
  piutangkaryawan,
  pembayaranpiutang,
  closingum,
  type_tax,
  pipeline,
  klaimcc,
  creditcard,
} from "./modules";

Vue.use(Vuex);

const baseUrl = process.env.VUE_APP_SERVICEURL;

export default new Vuex.Store({
  modules: {
    bank,
    selections,
    status,
    kategori,
    project,
    alokasi,
    usedFor,
    sites,
    basicConfig,
    mataUang,
    bod,
    satuan,
    user,
    publik,
    gudang,
    produk,
    ga,
    vpm,
    specialmenu,
    navigation,
    notification,
    kurir,
    notif,
    env,
    transaction,
    costCenter,
    umpd,
    typepage,
    accountpay,
    accountreceiveable,
    sppd,
    preloader,
    director,
    salesContract,
    financing,
    paymentschedule,
    terminRelease,
    penarikanFinancing,
    administrator,
    reconciliation,
    bankguarantee,
    cashonbank,
    bidbondrequest,
    bidbond,
    piutangkaryawan,
    pembayaranpiutang,
    closingum,
    type_tax,
    pipeline,
    klaimcc,
    creditcard,
  },
  state: {
    drawer: false,
    screen: mixin.methods.isMobile(),
    allKaryawan: [],
    header: [{ action: false }],
    atasan: [],
    //mataUang: [],
    defaultStatus: [
      {
        label: "Delivered",
        value: "delivered",
      },
    ],
    //navigation: [],
    supplierList: [],
    supplierType: [
      {
        id: 0,
        label: "Avionik",
        value: "Avionik",
      },
      {
        id: 1,
        label: "Non Avionik",
        value: "Non Avionik",
      },
    ],
    salesType: [
      {
        id: 0,
        label: "Repeat Order",
        value: "Repeat Order",
      },
      {
        id: 1,
        label: "Project Base",
        value: "Project Base",
      },
    ],
    enduser_dir: [],
    enduser_cc: [],
    enduser_cc_ticket: [],
    sppd_no_list: [],
    cc_pp_list: [],
    cc_emp_list: [],
    account_mngr:[],
    activityMARDEV: {
      type:['Project Penetration', 'Non Project'],
      activity:['FGD Workshop', 'Offset', 'Pameran Dalam Negeri', 'Pameran Luar Negeri']
    },
    tlc_CEO: 'ADI',
    bailout_value: 3000000
  },
  getters: {
    getDrawer: (state) => {
      return state.drawer;
    },
    getScreen: (state) => {
      return state.screen;
    },
    getAllKaryawan: (state) => {
      return state.allKaryawan;
    },
    getAtasan: (state) => {
      return state.atasan;
    },
    getNavigation: (state) => {
      return state.navigation;
    },
    getSupplierList: (state) => {
      return state.supplierList;
    },
    getSupplierType: (state) => {
      return state.supplierType;
    },
    getSalesType: (state) => {
      return state.salesType;
    },
    getBodDirektur: (state) => {
      return state.enduser_dir;
    },
    getEndUserCC: (state) => {
      return state.enduser_cc;
    },
    getEndUserCCTicket: (state) => {
      return state.enduser_cc_ticket;
    },
    getAccountMngr: (state) => {
      return state.account_mngr;
    },
    getMARDEVActivity: (state) => {
      return state.activityMARDEV
    },
    getTlc_CEO: (state) => {
      return state.tlc_CEO;
    },
    getBailoutValue: (state) => {
      return state.bailout_value;
    },
    getSppdNoList: (state) => {
      return state.sppd_no_list;
    },
    getCCPPNoList: (state) => {
      return state.cc_pp_list;
    },
    getCCEmpList: (state) => {
      return state.cc_emp_list;
    }
  },
  mutations: {
    DRAWER_TOGGLE: (state, value) => {
      Vue.set(state, "drawer", value);
    },
    HEADER_ACTION: (state, value) => {
      Vue.set(state, "header", value);
    },
    SCREEN: (state, value) => {
      Vue.set(state, "screen", value);
    },
    GET_ALL_KARYAWAN: (state, value) => {
      Vue.set(state, "allKaryawan", value);
    },
    GET_ATASAN: (state, value) => {
      Vue.set(state, "atasan", value);
    },
    NAVIGATION: (state, payload) => {
      Vue.set(state, "navigation", payload);
    },
    GET_ENDUSER_DIREKTUR: (state, value) => {
      Vue.set(state, "enduser_dir", value);
    },
    GET_ENDUSER_CC: (state, value) => {
      Vue.set(state, "enduser_cc", value);
    },
    GET_ENDUSER_CC_TICKET: (state, value) => {
      Vue.set(state, "enduser_cc_ticket", value);
    },
    GET_ACCOUNT_MANAGER: (state, value) => {
      Vue.set(state, "account_mngr", value);
    },
    GET_SUPPLIER_LIST: (state, value) => {
      Vue.set(state, "supplierList", value);
    },
    GET_SPPD_NO_LIST: (state, value) => {
      Vue.set(state, "sppd_no_list", value);
    },
    GET_CC_PP_LIST: (state, value) => {
      Vue.set(state, "cc_pp_list", value);
    },
    GET_CC_EMP_LIST: (state, value) => {
      Vue.set(state, "cc_emp_list", value);
    },
  },
  actions: {
    SEND_EVENT({ }, event) {
      socketio.sendEvent(event);
    },
    DRAWER_TOGGLE(store, value) {
      store.commit("DRAWER_TOGGLE", value);
    },
    HEADER_ACTION(store, value) {
      store.commit("HEADER_ACTION", value);
    },
    NAVIGATION_ACTION(store, payload) {
      if (payload !== undefined) {
        store.commit("NAVIGATION", payload);
      }
    },
    SCREEN_CHANGE_ACTION(store, value) {
      store.commit("SCREEN", value);
    },
    async FETCH_ALL_KARYAWAN(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "user/allkaryawan",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ALL_KARYAWAN", response.data.data);
          return store.state.allKaryawan;
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_ATASAN(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "user/atasanlangsung",
        params: {
          tlc: store.rootState.user.auth.username,
        },
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ATASAN", response.data.data);
          return store.state.atasan;
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_ENDUSER_DIREKTUR(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "klaim_direktur/end_user_klaim_direktur",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ENDUSER_DIREKTUR", response.data.data);
          return store.state.enduser_dir;
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_ENDUSER_CC(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "klaim_cc/end_user_klaim_cc",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ENDUSER_CC", response.data.data);
          return store.state.enduser_cc;
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_ENDUSER_CC_TICKET(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "lap_tiket_pd/kartu_kredit",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ENDUSER_CC_TICKET", response.data.data);
          return store.state.enduser_cc_ticket;
        })
        .catch((err) => {
          return err;
        });
    },
    
    async FETCH_SPPD_NO_LIST(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "lap_tiket_pd/sppd",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      }).then((response) => {
        store.commit("GET_SPPD_NO_LIST", response.data.data);
        store.commit("GET_CC_PP_LIST", response.data.data_pp);
        store.commit("GET_CC_EMP_LIST", response.data.karyawan);
        return store.state.sppd_no_list;
      }).catch((err) => {
        return err;
      });
    },

    async FETCH_ACCOUNT_MANAGER(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "main/account_manager_tlc",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_ACCOUNT_MANAGER", response.data.account_manager);
          return store.state.account_mngr;
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_SUPPLIER_LIST(store) {
      return await Axios({
        method: "get",
        url: baseUrl + "suplier/nama",
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("GET_SUPPLIER_LIST", response.data.data);
          return true;
        })
        .catch((err) => {
          return err;
        });
    },
  },
});
